import styled from 'styled-components';

export const ModalContainer = styled.div`
  margin: ${props => `${props.theme.space.none} ${props.theme.space['4.0']} ${props.theme.space['2.0']}`};
  ${props => props.theme.mediaQueries.smallDown} {
    margin: ${props => `${props.theme.space.none} ${props.theme.space['1.0']}`};
  }
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ModalTitleText = styled.h2`
  margin: ${props => `${props.theme.space['1.0']} ${props.theme.space['1.0']} ${props.theme.space['2.0']}`};
  text-align: center;
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-size: ${props => props.theme.fontSizes.headerTwo} !important;

  ${props => props.theme.mediaQueries.smallDown} {
    font-size: ${props => props.theme.fontSizes.headerThree} !important;
  }
  font-weight: ${props => props.theme.fontWeights.bold} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
`;

export const ModalInfoText = styled.p`
  margin-bottom: ${props => `${props.theme.space['1.0']}`};
  text-align: center;
  font-family: ${props => props.theme.fonts.circular} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  font-size: ${props => props.theme.fontSizes.body} !important;
  font-weight: ${props => props.theme.fontWeights.book} !important;
  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
`;
